module.exports = __webpack_public_path__ + "assets/b13.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b13.png
// module id = 598
// module chunks = 0